import React from 'react'
import { Table } from 'antd'
import './style.css';
const TableField = ({ columns, data, ...props }) => {
  return <Table columns={columns} dataSource={data} {...props} />;
};


export default TableField
